import React from "react";
import Breadcrumb from "../../breadcrumb";

const Header3Breadcrumb = (props) => {
  const { breadcrumb } = props;
  if (breadcrumb) {
    return (
      <>
        <div className="header3-breadcrumb container">
          <Breadcrumb breadcrumb={breadcrumb} />
          <style jsx>{`.header3-breadcrumb {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

@media screen and (min-width: 768px) {
  .header3-breadcrumb {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
}

@media screen and (min-width: 1280px) {
  .header3-breadcrumb {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
}
`}</style>
        </div>
      </>
    );
  }
  return null;
};
export default Header3Breadcrumb;
